import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class SimpleLineDetailModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formInputs: {
                quantity: null,
                clientRefNumber: null,
                gap_ra: null,
                modelNumber: null,
                itemDescription: null,
                itemFaultDescription: null,
            },
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func,
        createBookingLineDetail: PropTypes.func,
        updateBookingLineDetail: PropTypes.func,
        deleteBookingLineDetail: PropTypes.func,
        editMode: PropTypes.bool,
        line: PropTypes.object,
        lineDetail: PropTypes.object,
        isYP: PropTypes.bool,
        isAP: PropTypes.bool,
        isGW: PropTypes.bool,
    };

    static defaultProps = {
        isOpen: true,
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.lineDetail && newProps.lineDetail != this.props.lineDetail) {
            let formInputs = {
                quantity: newProps.lineDetail.quantity,
                clientRefNumber: newProps.lineDetail.clientRefNumber,
                gap_ra: newProps.lineDetail.gap_ra,
                modelNumber: newProps.lineDetail.modelNumber,
                itemDescription: newProps.lineDetail.itemDescription,
                itemFaultDescription: newProps.lineDetail.itemFaultDescription,
            };
            this.setState({ formInputs });
        }

        if (this.props.lineDetail && !newProps.lineDetail) {
            this.resetformInputs();
        }
    }

    notify = (text) => toast(text);

    resetformInputs = () => {
        this.setState({
            formInputs: {
                quantity: null,
                clientRefNumber: null,
                gap_ra: null,
                modelNumber: null,
                itemDescription: null,
                itemFaultDescription: null,
            }
        });
    }

    onInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formInputs = this.state.formInputs;
        formInputs[name] = value;
        this.setState({formInputs});
    }

    onSubmit(e) {
        e.preventDefault();
        const { formInputs } = this.state;
        const { editMode, line } = this.props;

        if (editMode) {
            this.props.updateBookingLineDetail(line, formInputs);
        } else {
            this.props.createBookingLineDetail(line, formInputs);
        }

        this.props.toggleModal();
        this.resetformInputs();
    }

    render() {
        const { isOpen, editMode, line, isYP, isAP, isGW } = this.props;
        const { formInputs } = this.state;

        return (
            <ReactstrapModal isOpen={isOpen} toggle={() => this.props.toggleModal()} className="simple-line-detail-modal">
                <ModalHeader toggle={() => this.props.toggleModal()}>LineDetail Modal</ModalHeader>
                <ModalBody>
                    <div className="line-detail-form">
                        <form onSubmit={(e) => this.onSubmit(e)} role="form" id="simple-line-detail-form">
                            <label>
                                <p>Quantity</p>
                                <input
                                    className="form-control"
                                    type="number"
                                    step="1"
                                    min="1"
                                    name="quantity"
                                    value={!isNaN(formInputs['quantity']) ? formInputs['quantity'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                    required={!isGW}
                                />
                            </label>
                            <label>
                                <p>{isAP ? 'Reference No. 1' : (isGW ? 'GW Ref No. 1' : (isYP ? 'Store Claim No.' : 'Ref No. 1'))}</p>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="clientRefNumber"
                                    value={formInputs['clientRefNumber'] ? formInputs['clientRefNumber'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                    // required={!isGW}
                                />
                            </label>
                            <label className={isYP ? 'none' : ''}>
                                <p>{isAP ? 'Reference No. 2' : (isGW ? 'GW Ref No. 2' : (isYP ? 'RA Number' : 'Ref No. 2'))}</p>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="gap_ra"
                                    value={formInputs['gap_ra'] ? formInputs['gap_ra'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                    // required={!(isYP || isGW)}
                                />
                            </label>
                            <label>
                                <p>Model Number</p>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="modelNumber"
                                    value={formInputs['modelNumber'] ? formInputs['modelNumber'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                    required={!isGW}
                                />
                            </label>
                            <label className={isYP ? 'none' : ''}>
                                <p>Item Description</p>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="itemDescription"
                                    value={formInputs['itemDescription'] ? formInputs['itemDescription'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                    required={!(isYP || isGW)}
                                />
                            </label>
                            <label className={isYP ? 'none' : ''}>
                                <p>Fault Description</p>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="itemFaultDescription"
                                    value={formInputs['itemFaultDescription'] ? formInputs['itemFaultDescription'] : ''}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </label>
                        </form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {editMode &&
                        <Button color="danger" onClick={() => this.props.deleteBookingLineDetail(line)}>Delete</Button>
                    }
                    <Button type="submit" form="simple-line-detail-form" color="primary">{editMode ? 'Update' : 'Submit'}</Button>{' '}
                    <Button color="secondary" onClick={() => this.props.toggleModal()}>Cancel</Button>
                </ModalFooter>
            </ReactstrapModal>
        );
    }
}

export default SimpleLineDetailModal;



// WEBPACK FOOTER //
// ./src/components/CommonModals/SimpleLineDetailModal.js